module.exports = __webpack_public_path__ + "public/SiteIcons/waving-hand.png?d55f75fd";